import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=7aaee59c&scoped=true&"
import script from "./AssignmentList.vue?vue&type=script&lang=js&"
export * from "./AssignmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaee59c",
  null
  
)

export default component.exports